import { render } from "./SidebarOptionsCard.vue?vue&type=template&id=005a4fc8&scoped=true"
import script from "./SidebarOptionsCard.vue?vue&type=script&lang=js"
export * from "./SidebarOptionsCard.vue?vue&type=script&lang=js"

import "./SidebarOptionsCard.vue?vue&type=style&index=0&id=005a4fc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005a4fc8"]])

export default __exports__